export const TEACHER_DEBIT_ITEM_TYPES = {
  lesson: 'Lekcja',
  salary: 'Wypłata',
  expense: 'Inne',
  underpayment: 'Niedopłata',
  overpayment: 'Nadpłata',
  advance: 'Zaliczka',
  absence: 'Nieobecność ucz.',
  additional: 'Dodatek'
}

export const TEACHER_PAYMENT_TYPES = {
  transfer: 'Przelew JDG',
  transferCompany: 'Przelew spółka',
  postalOrder: 'Przekaz pocztowy',
  other: 'Inne'
}

export const TEACHER_ACCOUNTS = {
  account1: 'Smart 1',
  account2: 'Smart 2',
  account3: 'Faktury 1',
  account4: 'Faktury 2'
}

export const getTeacherAccount = teacher => teacher?.account ?? ''

export const TEACHER_PAYMENT_TYPES_OPTIONS = [
  { label: TEACHER_PAYMENT_TYPES.transfer, value: 'transfer'},
  { label: TEACHER_PAYMENT_TYPES.transferCompany, value: 'transferCompany'},
  { label: TEACHER_PAYMENT_TYPES.postalOrder, value: 'postalOrder'},
  { label: TEACHER_PAYMENT_TYPES.other, value: 'other'},
]
